import promisifyRemoteActions from 'promisify-remote-actions';

export default process.env.NODE_ENV === 'production'
  ? promisifyRemoteActions(window[process.env.REACT_APP_SF_CONTROLLER])
  : require('./LocalTestData').default;
